module.exports = __webpack_public_path__ + "media/images/arrow-right-black-60d209acf4f9ea3801c807c16c33e0eb.svg";